// extracted by mini-css-extract-plugin
module.exports = {"main":"_6993","bd":"_18745","icon":"_2036","title":"_4731","desc":"_3464","actions":"_16407","confirm":"_11637"};